<template>
    <div>
        <div v-if="supports_conditions" class="text-right">
            <v-btn
                color="primary"
                :disabled="read_only"
                class="mb-4"
                @click="onClickAddConditionMessage"
            >
                Add Conditional Message...
            </v-btn>
        </div>

        <m-auto-message-condition-edit-dialog
            ref="condition-edit-dialog"
            @save="onEditConditionSave"
        />

        <v-alert
            v-if="template.conditions.length > 1"
            border="left"
            colored-border
            color="primary"
            elevation="2"
            type="info"
            dismissible
        >
            <strong>Note:</strong> Conditions are evaluated in order (i.e. the first condition that matches is the message that is sent) -- therefore, the order of your conditions matters.<br/><br/>You can move conditions up and down using the "move up" and "move down" buttons respectively.
        </v-alert>

        <v-expansion-panels v-if="template.conditions.length > 0" class="mt-4 mb-8">
            <v-expansion-panel
                v-for="(conditional, index) in template.conditions"
                :key="'panel-'+index"
            >
                <v-expansion-panel-header>
                    <strong>
                        <span v-html="conditional.description"/>
                    </strong>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                    <m-auto-message-message-ctrls
                        :send_from_choices="send_from_choices"
                        :link_shortener_host_choices="link_shortener_host_choices"
                        :message_pattern_context="template.template_context"
                        :value="conditional"
                        :disable_mode="organization_account != null && organization_account.is_sandbox_organization"
                        :read_only="read_only"
                        @input="onChangeConditionMessageCtrls"
                    />

                    <div class="text-right mt-1">
                        <v-btn
                            v-if="conditional.condition_index > 0"
                            :disabled="read_only"
                            class="mr-4"
                            @click="onClickMoveConditionalUp(conditional)"
                        >
                            Move Up...
                        </v-btn>

                        <v-btn
                            v-if="conditional.condition_index+1 <= template.conditions.length-1"
                            :disabled="read_only"
                            class="mr-4"
                            @click="onClickMoveConditionalDown(conditional)"
                        >
                            Move Down...
                        </v-btn>

                        <v-btn
                            :disabled="read_only"
                            class="mr-4"
                            @click="onClickDeleteConditional(conditional)"
                        >
                            Delete this conditional message...
                        </v-btn>

                        <v-btn
                            :disabled="read_only"
                            @click="onClickEditConditions(conditional)"
                        >
                            Edit Conditions...
                        </v-btn>
                    </div>

                </v-expansion-panel-content>

            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header><strong>Otherwise (i.e. if none of the above conditions match)</strong></v-expansion-panel-header>
                <v-expansion-panel-content>
                    <m-auto-message-message-ctrls
                        :send_from_choices="send_from_choices"
                        :link_shortener_host_choices="link_shortener_host_choices"
                        :message_pattern_context="template.template_context"
                        :value="template"
                        @input="onChangeDefaultMessageCtrls"
                        :disable_mode="organization_account != null && organization_account.is_sandbox_organization"
                        :read_only="read_only"
                        default_message_control
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div v-else>
            <m-auto-message-message-ctrls
                :send_from_choices="send_from_choices"
                :link_shortener_host_choices="link_shortener_host_choices"
                :message_pattern_context="template.template_context"
                :value="template"
                :disable_mode="organization_account != null && organization_account.is_sandbox_organization"
                :read_only="read_only"
                default_message_control
                @input="onChangeDefaultMessageCtrls"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true
        },
        supports_conditions: {
            type: Boolean,
            default: false
        },
        condition_profiles: {
            type: Array,
            default: () => []
        },
        integration_crm_summaries: {
            type: Array,
            default: () => []
        },
        send_from_choices: {
            type: Array,
            default: () => []
        },
        link_shortener_host_choices: {
            type: Array,
            default: () => []
        },
        organization_account: {
            type: Object,
            default: null
        },
        read_only: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onClickAddConditionMessage() {
            const condition = {
                label: 'Conditional message',
                constraints: [],
                send_mode: 'manual',
                send_from: this.template.send_from,
                message_patterns: this.template.message_patterns,
                condition_index: -1,
            };

            this.$refs['condition-edit-dialog'].showDialog(condition, this.condition_profiles, this.integration_crm_summaries);
        },

        onEditConditionSave(condition) {
            this.$emit('save', condition);
        },

        onChangeConditionMessageCtrls(newValue) {
            this.$emit('update-condition', newValue);
        },

        onChangeDefaultMessageCtrls(newValue) {
            this.$emit('update-default', newValue);
        },

        onClickMoveConditionalUp(conditional) {
            this.$emit('move-up', conditional);
        },

        onClickMoveConditionalDown(conditional) {
            this.$emit('move-down', conditional);
        },

        onClickDeleteConditional(conditional) {
            this.$emit('delete', conditional);
        },

        onClickEditConditions(conditional) {
            this.$refs['condition-edit-dialog'].showDialog(conditional, this.condition_profiles, this.integration_crm_summaries);
        }
    }
}
</script>
